import React from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Button from 'fe-design-base/molecules/Button';
import { Map as ImmutableMap } from 'immutable';

import { cxHelpers } from 'util/className';
import { parsedCreatedAt } from 'util/dateTime';
import { toI18n } from 'util/i18n';

import { BaseListItem } from '../BaseListItem';
import * as constants from '../constants';

const { cxEl } = cxHelpers('BaseListItem');

type AlertsListItemProps = {
  item: ImmutableMap<string, any>;
  desc?: string;
  onEdit: () => void;
  onDismiss: () => void;
  icon?: string;
  dismissButton?: string;
  editButton?: string;
  title?: string;
};

const AlertsListItem = ({
  item,
  desc,
  onEdit,
  onDismiss,
  icon,
  dismissButton = toI18n('notifications.alerts.buttons.dismiss'),
  editButton = toI18n('notifications.alerts.buttons.edit'),
}: AlertsListItemProps) => {
  const createdAtDate = () => parsedCreatedAt(item);

  const type = () => item.get('type') as string;

  const title = () => item.get('title') as string | undefined;

  const isJobApplication = () => type() === 'job_application';

  const renderButtons = () => (
    <Box row justifyContentSpaceBetween mt={8}>
      <div>
        {type() !== 'clock_out' && (
          <Button
            className={cxEl('dismiss')}
            onClick={onDismiss}
            variant="tertiary"
          >
            {dismissButton}
          </Button>
        )}
      </div>
      <Button className={cxEl('edit')} onClick={onEdit} variant="primary">
        {editButton}
      </Button>
    </Box>
  );

  const leftBasis = icon ? constants.LEFT_COLUMN_WIDTH : 0;

  return (
    <BaseListItem
      icon={icon}
      titleI18n={`notifications.alerts.${type()}.title`}
      date={createdAtDate()}
      title={(isJobApplication() && title()) || undefined}
    >
      <Box alignItemsStart>
        <Box flexBasis={leftBasis} flexShrink={0} />

        <Box flexGrow={1}>
          <Text variant="bodySm">{desc}</Text>
        </Box>
      </Box>
      {renderButtons()}
    </BaseListItem>
  );
};

export default React.memo(AlertsListItem);
